import { generatePath, useLocation, useNavigate } from 'react-router';

import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { LocationStateType } from '@/shared/config';
import { getSegmentronReportLink } from '@/shared/lib';

import { getReportPath } from '../lib';

export const useNavigateToReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // NOTE: type casting is necessary for typification location.state
  const locationState = location?.state as LocationStateType;

  return async ({
    reportID,
    reportType,
    patientID,
    CBCTOrthoPDFUrl,
    search = '',
  }: {
    reportID: string;
    reportType: ReportType;
    patientID: string;
    CBCTOrthoPDFUrl: string;
    search?: string;
  }) => {
    const isCBCTOrthoPDFReport =
      reportType === ReportType.ReportType_CBCT_OrthoSlides;

    const isSegmentronReport = [
      ReportType.ReportType_CBCT_Segmentation,
      ReportType.ReportType_CBCT_IOS_Superimposition,
      ReportType.ReportType_IOS_Segmentation,
      ReportType.ReportType_StudioImplant,
      ReportType.ReportType_StudioOrtho,
    ].includes(reportType);

    if (isCBCTOrthoPDFReport) {
      window.open(CBCTOrthoPDFUrl, '_blank', 'noopener,noreferrer');
    } else if (isSegmentronReport) {
      window.open(
        getSegmentronReportLink(reportID, reportType),
        '_blank',
        'noopener,noreferrer',
      );
    } else if (patientID && reportID) {
      navigate(
        {
          pathname: generatePath(getReportPath(reportType), {
            patientID,
            reportID,
          }),
          search,
        },
        {
          state: {
            ...locationState,
            lastPositionPatientProfile: window.pageYOffset,
          },
        },
      );
    }
  };
};
